// TranslationTextEdit.jsx
import React from "react";
import TransliterateInput from "../common/TransliterateInput";

const TranslationTextEdit = ({
  fileContent,
  setFileContent,
  responseData,
  setResponseData,
  setFile,
  setFileName,
  targetLang = "hin",
  inputLang,
  isUrdu = false,
  isUrdu_o = false,
}) => {
  return (
    <div className="flex flex-col space-y-1 space-x-2">
      <div className="flex pb-4">
        {/* Source Textarea */}
        <div className="relative w-full h-80 rounded-l-lg mr-4">
        <TransliterateInput
          value={fileContent}
          onChange={setFileContent}
          targetLang={inputLang}
          isUrdu = {isUrdu}
          placeholder="Start typing in Source – suggestions appear below"
        />
          <div
            className="absolute top-2 right-2 text-lg font-bold text-gray-600 hover:text-red-500 cursor-pointer"
            onClick={() => {
              setFileContent("");
              setFileName?.("");
              setFile?.(null);
            }}
          >
            X
          </div>
        </div>

        {/* Target: Live Transliteration Input */}
        <TransliterateInput
          value={responseData}
          onChange={setResponseData}
          targetLang={targetLang}
          isUrdu = {isUrdu}
          placeholder="Start typing in English – suggestions appear below"
        />
      </div>
    </div>
  );
};

export default TranslationTextEdit;